<template>
  <div id="app">
    <v-app>
      <v-content v-if="authenticated">
        <app-bar :user="user" :logout="logout" />
        <router-view :keycloak="keycloak" :authenticated="authenticated" />
      </v-content>
    </v-app>
  </div>
</template>
<script>
import Keycloak from "keycloak-js";
import axios from "axios";
import AppBar from "@/components/AppBar";
import moment from "moment";

const {
  VUE_APP_KC_URL: url,
  VUE_APP_KC_REALM: realm,
  VUE_APP_KC_CLIENT_ID: clientId,
} = process.env;

const kc = new Keycloak({
  url,
  realm,
  clientId,
});

axios.interceptors.request.use((config) =>
  kc
    .updateToken(30)
    .then(() => {
      config.headers.Authorization = "Bearer " + kc.token;
      return config;
    })
    .catch(() => {
      kc.login();
    })
);

export default {
  name: "App",
  components: {
    AppBar,
  },
  data: () => ({
    keycloak: undefined,
    authenticated: false,
    user: undefined,
  }),
  methods: {
    logout: function () {
      this.keycloak.logout();
    },
  },
  mounted() {
    moment.locale("fr");
    kc.init({
      onLoad: "login-required",
      checkLoginIframe: false,
    })
      .then(async (authenticated) => {
        if (!authenticated) {
          return kc.login();
        }
        const access = kc.resourceAccess && kc.resourceAccess[clientId];
        if (!access || !access.roles.includes("admin")) {
          return kc.logout();
        }
        this.keycloak = kc;
        this.user = await kc.loadUserInfo();
        this.authenticated = authenticated;

        setInterval(() => {
          kc.updateToken(30).catch(() => kc.login());
        }, 10000);
      })
      .catch(() => {
        kc.login();
      });
  },
};
</script>
